import { Component } from '@angular/core';
/**
declare  spinner component
 *  
*/
@Component({
    selector: 'app-spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.scss'],
    standalone: false
})
export class SpinnerComponent {
}
